import {
    Component,
    computed,
    effect,
    Input,
    OnInit,
    signal,
    TemplateRef,
    ViewChild,
    WritableSignal
} from '@angular/core';
import {
    ArchivoVigenteComponent
} from "../../../users/proyectos/components/nuevo-proyecto/components/archivo-vigente/archivo-vigente.component";
import {Button} from "primeng/button";
import {DropdownModule} from "primeng/dropdown";
import {FileUpload, FileUploadModule} from "primeng/fileupload";
import {MessagesModule} from "primeng/messages";
import {NgIf} from "@angular/common";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {MessageService, PrimeTemplate} from "primeng/api";
import {SharedModule} from "../../shared.module";
import {TagModule} from "primeng/tag";
import {TooltipModule} from "primeng/tooltip";
import {
    ArchivoItem,
    ArchivoTipoEnum,
    CatalogoInterface,
    FileCase,
    TenenciaEnum,
    TenenciaItem
} from "../../../users/interfaces/proyecto.interface";
import {defaultProyectoPerfil, ProyectoPerfil} from "../../../users/interfaces/perfil.interface";
import {CatalogoService} from "../../services/catalogo-service";
import {FileUtilsService} from "../../services/file-utils-service";
import {PersonasService} from "../../services/personas-service";
import {PasosPersonasService} from "../../../users/proyectos/components/nuevo-proyecto/services/pasos-personas.service";
import {catchError, throwError} from "rxjs";
import {PrimeNgModule} from "../../prime-ng/prime-ng.module";
import Swal from "sweetalert2";
import {DraftProjectService} from "../../../users/proyectos/services/draft-project.service";
import {DropdownItem, ErrorMessages, FieldPersonas,} from "../../interfaces/personas-proyecto.interface";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {FieldsParserService} from "../solicitud-requisitos/rq-form/services/fields-parser.service";
import {ComponentsPasosComponent} from "./components-pasos/components-pasos.component";
import {
    PersonasProyectoTableComponent
} from "../../../users/proyectos/components/nuevo-proyecto/components/personas-proyecto-table/personas-proyecto-table.component";
import {TipoAutorizaciones} from "../../interfaces/shared-interface";

@Component({
  selector: 'app-pasos-personas-proyectos',
  standalone: true,
    imports: [
        ArchivoVigenteComponent,
        Button,
        DropdownModule,
        FileUploadModule,
        MessagesModule,
        NgIf,
        OverlayPanelModule,
        PrimeTemplate,
        SharedModule,
        TagModule,
        TooltipModule,
        PrimeNgModule,
        ReactiveFormsModule,
        ComponentsPasosComponent,
        PersonasProyectoTableComponent
    ],
  providers:[MessageService,FieldsParserService],
  templateUrl: './pasos-personas-proyectos.component.html',
  styleUrl: './pasos-personas-proyectos.component.scss'
})
export class PasosPersonasProyectosComponent implements OnInit{
    @Input() fieldJson!: FieldPersonas<string>;
    @Input() errors:ErrorMessages[]=[];
    @Input() form!: FormGroup;
    activeIndex: WritableSignal<number> = signal(0)
    validateRunEffect = signal(true);
    tenenciaCatalogo: TenenciaItem[] = []
    tenenciaArchivoTipo: CatalogoInterface[] = []
    dataFileSeleted: ArchivoItem[] = [];
    autorizaciones:ProyectoPerfil [] =[];
    dropDownSeleted: DropdownItem | null = null
    personaEncontradaTemp: ProyectoPerfil = null!
    limpiarBusquedaPersona: boolean = false
    showCargarEscritura: boolean = false
    buttonPropietario: Boolean = false;
    openDialog: boolean = false;
    banderaBotonConfirmar: any | boolean = false;
    tituloFileUpload:string='';
    informacion:string='';
    hashDelArchivo: any = null
    templateResponse!: TemplateRef<any>;
    protected readonly TipoAutorizaciones = TipoAutorizaciones;
    @ViewChild('cargaArchivos') fileUpload: FileUpload | any;
    constructor(private messageService: MessageService, private catalogoService: CatalogoService, protected fileUtilsService: FileUtilsService, public personasService: PersonasService,
                private pasosPersonasService: PasosPersonasService, protected draftProjectService: DraftProjectService) {
        effect(() => {
            if (this.personasService.selected() != null) {
                if (this.personaEncontradaTemp == null) {
                    this.personaEncontradaTemp = defaultProyectoPerfil();
                }
                this.personaEncontradaTemp.personaInfo = this.personasService.selected();
                this.personaEncontradaTemp.uniqueId = this.personasService.selected().uniqueId;
                this.personaEncontradaTemp.idPersona = Number.parseInt(this.personasService.selected().idPersona);
                this.buttonPropietario = false
                console.log('this.personasService.selected() ->', JSON.stringify(this.personasService.selected()));
                console.log('this.personaEncontradaTemp      ->', JSON.stringify(this.personaEncontradaTemp));
            }
        });
    }

    ngOnInit(): void {
        this.getTenencia();
        this.getTipoArchivos();
        if(this.fieldJson.step==3){
            this.tituloFileUpload="Contrato de comodato"
            this.informacion="Es el documento de contrato de comodato certificado por notario"
        }
    }

    private consultarPorUniqueId(uniqueId:string){
        if(uniqueId=='null' && uniqueId==null || uniqueId=="0"  || uniqueId== "" || uniqueId == undefined) {
            return;
        }
        this.personasService.consultarInfoPorUniqueIds(uniqueId);
        this.personasService.validStatuConsultaPorTitular.set(true);
    }
    /**
     * Tenencia legal en creacion de proyecto requiere que se especifique el propietario.
     * idTenencia = 3 --> Propierario.
     */
    validarErroresPasos(field: FieldPersonas<string>) {
        let valid : boolean = false;
        if(field?.step==2) {
            if (this.draftProjectService.draftProject().tenenciaLegal.length != 0) {
                valid=this.draftProjectService.draftProject().tenenciaLegal.some(prop => prop.idTenencia == TenenciaEnum.Propietario);

            } else {
                return valid
            }
        }
        if(field?.step==3) {
            valid=this.draftProjectService.draftProject().tenenciaLegal.some(prop => prop.idTenencia == TenenciaEnum.RepresentanteLegal);
        }
        if(field?.step==4) {
            valid=true;
        }
        return valid;

    }
    private duplicatedFileError(customError?: string) {
        let error = "";
        if (customError) {
            error = customError;
        }
        Swal.fire({
            position: "center",
            icon: "error",
            title: error,
            showConfirmButton: true,
            timer: 3000
        }).then(r => console.error(error));
    }
    private duplicatePersonaTenencia(customError?: string) {
        let error = "";
        if (customError) {
            error = customError;
        }
        Swal.fire({
            position: "center",
            icon: "error",
            title: error + this.complementErrorAlert(this.fieldJson.step),
            showConfirmButton: true,
            timer: 3000
        }).then(r => console.error(error));
    }

    complementErrorAlert(paso:number):string{
        let mssg = ""
        if(paso){
            if(paso === 2){
                mssg="\npara la tenencia seleccionada."
                return mssg;
            }
            if(paso === 3){
                mssg="\npara representante legal."
                return mssg;
            }
            if(paso === 4){
                mssg="\npara profesional y planos."
                return mssg;
            }
        }
        return mssg
    }

    validacionButton(): boolean {
        return (this.fieldJson?.step === 2 && (!this.dropdown || !this.personasService.selected())) ||
            (this.fieldJson?.step == 3 && !this.personasService.selected()) ||
            (this.fieldJson?.step == 3 && this.personasService.validStatuConsultaPorTitular() && (this.draftProjectService.draftProject().idTitular!=="" || this.draftProjectService.draftProject().idTitular!=="0")) ||
            (this.fieldJson?.step == 4 && !this.personasService.selected()) ||
            (this.fieldJson?.step == 4 && this.personasService.validStatuConsultaPorTitular() && (this.draftProjectService.draftProject().idTitular!=="" || this.draftProjectService.draftProject().idTitular!=="0"))
    }

    onDialogClosed(event: boolean) {
        this.openDialog = event;
    }

    onFileCheck(event: any) {
        this.dataFileSeleted = event;
        this.procesarPersonaEncontradaArchivo(FileCase.ReuseFile)
    }

    openDialogFile() {
        this.openDialog = true;
    }

    setOnResponseUserEmitter(template: TemplateRef<any>){
        this.templateResponse=template
    }
    /*
    gets
    */
    get dropdown() {
        return this.dropDownSeleted
    }

    get idDropdown() {
        return (this.dropDownSeleted ? this.dropDownSeleted.key : null)
    }

    getTenencia() {
        this.pasosPersonasService.getTenenciaList([])
            .pipe(
                catchError(error => {
                    const status = error.status
                    if (status == '400' || status == '404') {
                        this.messageService.add({
                            severity: 'error', summary: '', detail: 'Error al obtener la información de tenencias'
                        });
                    }
                    return throwError(error.statusText);
                })
            )
            .subscribe(
                resp => {
                    this.tenenciaCatalogo = resp;
                }
            )
    }

    getTipoArchivos() {
        this.catalogoService.getCatalogo("archivo_tipo")
            .subscribe({
                next: (result) => {
                    this.tenenciaArchivoTipo = result;
                },
                error: (error) => {
                },
                complete: () => {
                    console.log(`archivo_tipo ->` + this.constructor.name)
                }
            });
    }

    /**
     *Este metodo obtiene los idTipoArchivo para los diferentes pasos tenencia legal, representante legal y planos
     * La informacion se guarda en ARCHIVOS_PROYECTO, TENENCIA_PROYECTO y SOLICITUD_DETALLE_RE que se procesa desde el FU.
     *El metodo se utiza para agregar la informacion la lista personaEncontradaTemp
     */
    obtenerTipoArchivo(items: CatalogoInterface[] | null) {
        if ((!items || items.length === 0)) {
            return null;
        }
        let obtenerId: string | number | null = null;
        /** Caso 1:*/
        if (this.fieldJson.step == 2 || this.fieldJson.step==4) {
            /**
             *Obtener el idTipoArchivo que se va cargar y que selecciona en tenencia o profesionales planos*/
            if (items && items.length > 0) {
                switch (this.idDropdown) {
                    case "6":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Prominentecomprador.toString() || tipo.descripcion === 'Prominente Comprador')?.id || null;
                        break;
                    case "4":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Planosactuales.toString() || tipo.descripcion === 'Planos actuales')?.id || null;
                        break;
                    case "3":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Escrituramatrizcompraventa.toString() || tipo.descripcion === 'Escritura matriz compra-venta')?.id || null;
                        break;
                    case "2":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Contratodearrendamiento.toString() || tipo.descripcion === 'Contrato de arrendamiento')?.id || null;
                        break;
                    case "1":
                        obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Contratodecomodato.toString() || tipo.descripcion === 'Contrato de comodato')?.id || null;
                        break;
                    default:
                        break;
                }
            }
        }
        /** Caso 2:*/
        if (this.fieldJson.step == 3) {
            /**
             Obtener el idTipoArchivo que se va cargar para el representante legal
             */
            if (items && items.length > 0) {
                obtenerId = items.find(tipo => tipo.id === ArchivoTipoEnum.Representantelegal.toString() || tipo.descripcion === 'Representante legal')?.id || null;
            }
        }
        return obtenerId;
    }

    /**filtro que obtiene id de los requisitos relacionados con la tenencia*/
    getIdRequisito(tipo: TenenciaEnum) {
        return this.tenenciaCatalogo.find(tenencia => tenencia.idTenencia.toString() === tipo)?.idRequisito!;
    }
    /**filtro que obtiene los id de tenencia*/
    getIdTenencia(tipo: TenenciaEnum) {
        return this.tenenciaCatalogo.find(tenencia => tenencia.idTenencia.toString() === tipo)?.idTenencia!;
    }

    getArchivosParam(tipos: string[], uniqueId: string) {
        this.personasService.getObtenerArchivosPersona(tipos, uniqueId);
    }

    agregarPropietario(autoAgregar: boolean = false) {
        console.log(`autoAgregar: ${autoAgregar}`)
        console.log(`this.fileUtilsService.file: `, this.fileUtilsService.file)
        if (!this.fileUtilsService.file) {
            this.messageService.add({
                severity: 'error', summary: '',
                detail: 'Error al agregar los datos, favor cargar el archivo.'
            });
            return;
        }
        this.procesarPersonaEncontradaArchivo(FileCase.FileUpload);
    }

    procesarPersonaEncontradaArchivo(caso: number) {
        try {
            console.log("#######################################################")
            console.log(`activeIndex:` + this.activeIndex)
            console.log("#######################################################")
            let idTipoArchivo = this.obtenerTipoArchivo(this.tenenciaArchivoTipo)!;
            if (!idTipoArchivo) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Tipo de archivo no válido o no permitido",
                    showConfirmButton: true,
                }).then((result) => {
                    console.log("Tipo de archivo no válido o no permitido")
                });
            }
            if (this.fieldJson?.step == 2 || this.fieldJson?.step == 4) {
                this.personaEncontradaTemp['tipo_propietario'] = this.dropDownSeleted != null ? this.dropDownSeleted.descripcion : ''
                this.personaEncontradaTemp['idTenencia'] = this.dropDownSeleted != null ? Number.parseInt(this.dropDownSeleted.key) : 0;
                if (this.idDropdown == TenenciaEnum.Propietario) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.dropDownSeleted?.idRequisito!;
                } else if (this.idDropdown == TenenciaEnum.Arrendatario) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.dropDownSeleted?.idRequisito!;
                } else if (this.idDropdown == TenenciaEnum.Conmodato) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.dropDownSeleted?.idRequisito!;
                } else if(this.idDropdown == TenenciaEnum.Profesionales) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.dropDownSeleted?.idRequisito!;
                }else if(this.idDropdown == TenenciaEnum.ProminenteComprador) {
                    this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                    this.personaEncontradaTemp["idRequisito"] = this.dropDownSeleted?.idRequisito!;
                } else {
                    console.error(`error en la tenencia seleccionada`);
                }
            }
            if (this.fieldJson?.step == 3) {
                this.personaEncontradaTemp['tipo_propietario'] = 'N/A'
                this.personaEncontradaTemp['idTenencia'] = this.getIdTenencia(TenenciaEnum.RepresentanteLegal)!;
                this.personaEncontradaTemp['idTipoArchivo'] = idTipoArchivo;
                this.personaEncontradaTemp["idRequisito"] = this.getIdRequisito(TenenciaEnum.RepresentanteLegal)!;
            }
            if (this.hashDelArchivo !== null && this.fileUtilsService.file && caso === FileCase.FileUpload!) {
                //Caso 1: archivos que se cargan mediante el fileUpload
                this.personaEncontradaTemp['archivo'] = this.fileUtilsService.file
                this.personaEncontradaTemp['hash'] = this.hashDelArchivo
                this.personaEncontradaTemp['nombreArchivo'] = this.fileUtilsService.file.name
                this.personaEncontradaTemp['idPasoGeneralidades'] = this.fieldJson?.step;
                this.personaEncontradaTemp['caso'] = caso;
                console.log('archivoSeleccionado-> ', this.fileUtilsService.file);
                console.log('hashDelArchivo-> ', this.hashDelArchivo);
            } else if (this.dataFileSeleted.length > 0 && this.dataFileSeleted[0].hash !== null && this.dataFileSeleted[0].hash !== ""
                && caso === FileCase.ReuseFile!) {
                //Caso 2: archivos que se seleccionan mediante el dialog
                this.personaEncontradaTemp['hash'] = this.dataFileSeleted[0].hash
                this.personaEncontradaTemp['nombreArchivo'] = this.dataFileSeleted[0].nombre
                this.personaEncontradaTemp['idPasoGeneralidades'] = this.fieldJson?.step;
                this.personaEncontradaTemp['caso'] = caso;
                console.log('hashDelArchivo-> ', this.dataFileSeleted[0].hash);
            }
            // Obtener el hash del archivo que se desea agregar a la lista temporal y se previsualizan en la tabla
            const hashExistente = this.draftProjectService.draftProject().tenenciaLegal.some(prop => prop.hash === this.personaEncontradaTemp.hash);
            //Validar que la persona que ya se encuentra en la lista de tenencia no se pueda duplicar para la misma tenencia seleccionada
            const personaExiste = this.draftProjectService.draftProject().tenenciaLegal.some(prop => prop.idPersona === this.personaEncontradaTemp.idPersona!
                && prop.idTenencia === this.personaEncontradaTemp.idTenencia);
            if(personaExiste){
                this.duplicatePersonaTenencia(`La persona ya fue asignada` );
                return;
            }
            if (!hashExistente) {
                this.personaEncontradaTemp['pageRefresh']=false;
                this.draftProjectService.draftProject.update(draft => ({
                    ...draft, tenenciaLegal: [...draft.tenenciaLegal, this.personaEncontradaTemp]
                }));
                this.personaEncontradaTemp = null!;
                this.limpiarBusquedaPersona = true;
                this.banderaBotonConfirmar = false;
                this.buttonPropietario = true;
                this.draftProjectService.existeTenencia.set([...this.draftProjectService.draftProject().tenenciaLegal]); //obtener tenecias para validacion
            } else {
                this.duplicatedFileError('Archivo especificado ya se encuentra en la lista')
                this.fileUpload.clear(); //limpiando para cargar otro archivos
                this.buttonPropietario = true;
            }
            console.log('this.personaEncontradaTemp ->', JSON.stringify(this.personaEncontradaTemp));
            console.log("this.datosProyectoService.draftProject().tenenciaLegal-> ", JSON.stringify(this.draftProjectService.draftProject().tenenciaLegal));
            this.fileUpload.clear(); //limpiando para cargar otro archivos
            this.personasService.limpiarSeleccion();
            setTimeout(() => {
                this.limpiarBusquedaPersona = false
                this.buttonPropietario = true;
            }, 2000)
        } catch (e) {
            console.log(e)
        }
    }

    async onFileUpload(event: any) {
        const estado = await this.fileUtilsService.fileUploadToBuffer(event, this.fileUpload);
        this.hashDelArchivo = this.fileUtilsService.hash;
        if (estado != 1) {
            this.messageService.add({
                severity: 'error', summary: '',
                detail: 'Archivo no cargado, fallo el proceso de carga'
            });
            this.buttonPropietario = true;
            this.fileUpload.clear();
            return;
        }
        this.agregarPropietario(true);
        this.buttonPropietario = true;
        this.fileUpload.clear();
        console.log("Resultado verificación:-> ", estado);
    }

    /**
     * Validacion para que el formulario aunque tenga diferentes elementos
     * solo dibuje o se renderiza los son parte de validTypes
     * diferente controlType*/
    isValidControlType(controlType: string): boolean {
        const validTypes = ['textbox','textboxNumber', 'dropdown', 'multiselect'];
        return validTypes.includes(controlType);
    }

    onEmitterSelectDropdown(event: {dropDownItem: DropdownItem; tituloFileUpload: string; informacion: string; componetKey:string}) {
        if(!event.dropDownItem){//limpiar lista
            if(event.componetKey==='titulares'){
                this.draftProjectService.draftProject().idTitular='';
            }
        }
        if(event.componetKey==='titulares'){
            //obtiene el uniqueId de la persona que a sido seleccionada como titular
            this.draftProjectService.draftProject().idTitular=event.dropDownItem.key;
            this.personasService.limpiarSeleccion();
        }
        this.tituloFileUpload=event.tituloFileUpload;
        this.informacion=event.informacion;
        this.dropDownSeleted=event.dropDownItem
    }
    onEmitterInputNumber(event:any){
        this.draftProjectService.draftProject.set({...this.draftProjectService.draftProject(),montoInversion:event});
    }
    effectSelected = effect(() => {
        if (this.validateRunEffect() && this.personasService.selected() !== null) {
            let idTipoArchivo: string[] = [this.obtenerTipoArchivo(this.tenenciaArchivoTipo)?.toString()!];
            this.getArchivosParam(idTipoArchivo, this.personasService.selected()?.uniqueId);
        }
    }, {allowSignalWrites: true});

    countFile = computed(() => {
        if (this.personasService.selected() && this.personasService.selected()?.uniqueId != null) {
            return this.personasService.archivos()?.length;
        }
        return 0;
    });
}
